'use client';

import { getFlipsterUrl } from '@flipster/features/src/shared/urls';
import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';

export const ShareButton = ({ slug }: { slug: string }) => {
  const copy = useCopy(<FormattedMessage id='Competition.r251215.Link_copied_successfully' />);

  const handleClick = () => {
    // 랜딩 페이지의 canonical 링크 (webview에서도 flipster.io 도메인으로 복사)
    const path = `/marketing/${slug}`;
    const url = `${getFlipsterUrl()}${path}`;
    copy(url);
  };

  return (
    <Button
      hierarchy='secondary'
      color='accent'
      size='large'
      label={<FormattedMessage id='Common.r250401.Share' />}
      css={{ px: 12 }}
      onClick={handleClick}
    />
  );
};
